<div [ngClass]="commonService.isHidden ?'':'container-fluid'">
    <div class="card-block" style="margin-left: 20px; margin-right: -12px;">
        <div class="head-block-title">
            <div class="row">
                <div class="col-md-8">
                    <span class="listHeaderText">Bookings ({{bookingListData?.length}})</span>
                </div>
                <div class="col-md-4 d-flex" style="justify-content: flex-end;">
                    <button class="btn btn-primary d-flex align-items-center" data-toggle="modal"
                        data-target="#bookingModalRight" (click)="changeAddUpdateModalState(null,'add')">
                        <img src="../../../../assets/images/addicon.svg" aria-hidden="true" class="icon-img">
                        <span class="add-btn-text">Add</span>
                    </button>
                    &nbsp; &nbsp;
                    <export [showIconOnly]="false" [data]="selectedExportData"></export>
                </div>
            </div>
        </div>

        <div class="main-field">
            <div class="main-block-content">
                <div class="table-container">
                    <app-common-table-dark [columnDefs]="columnDefs" [data]="bookingListData" [rowStyles]="rowStyles"
                        [enableRowStyles]="true" (commonDropdownChange)="onCommonTableDropdownChange($event)"
                        (selectedRowsChange)="onSelectedRowsChange($event)">
                    </app-common-table-dark>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Booking Mobile view-->
<div class="content-area">
    <span class="listHeaderText">Bookings ({{bookingListData?.length}})</span>
    <div class="row" style="position: relative;">
        <div class="col-md-6 export-div">
            <export [mobileView]="true" [data]="bookingListData" [columns]="exportColumns"></export>
        </div>
        <div class="col-md-6 d-flex" class="positioned-flex">
            <button class="btn btn-primary closeModal d-flex align-items-center"
                (click)="changeAddUpdateModalState(null,'add')">
                <img src="../../../../assets/images/addicon.svg" aria-hidden="true" class="icon-img">
                <span class="add-btn-text"> Add</span>
            </button>
        </div>
    </div>

    <div class="searchtext">
        <div class="row">
            <div class="col-md-8">
            </div>
            <div class="col-md-2">
                <span>
                    <input type="search" class="form-control" placeholder="Search Booking" style="height: 33px;"
                        [(ngModel)]="filterTerm" [ngModelOptions]="{standalone: true}">
                </span>
            </div>
        </div>
    </div>
    <div class="row row-cards-one">
        <div class="col-md-12 col-lg-3 col-xl-3">
            <div class="mycard bg1" *ngFor="let booking of bookingListData | filter: filterTerm">
                <div class="left">
                    <tr>
                        <td>
                            <h6>
                                <b><i class="fa fa-user" aria-hidden="true" style="margin-bottom: 10px;">
                                    </i> {{booking?.clientDetail?.nameInitialsName}}.
                                    {{ booking?.clientDetail?.firstName }}
                                    {{ booking?.clientDetail?.lastName }} </b><br>
                                <b *ngIf="showContactIcon">

                                    <i class="fa fa-eye"
                                        (click)="onClickEyeOfContactColumn(booking?.contactNumber)"></i>

                                    <!-- <i class="fa fa-phone" aria-hidden="true" style="margin-bottom: 10px;">
                                    </i> {{booking?.contactNumber}} -->
                                </b><br>
                                <i href="tel:{{booking.contactNumber}}"></i>
                                <b><i class="fa fa-inr" aria-hidden="true" style="margin-bottom: 10px;">
                                    </i> {{booking?.amount}}</b>
                            </h6>
                        </td>
                    </tr>
                </div>
                <div class="right d-flex align-self-center">
                    <tr>
                        <td>
                            <h6>
                                <div class="dropdownMenu" style="display: block;"
                                    (click)="toggleActonMenu(booking?.id)">
                                    <div>
                                        <img src="assets/images/Action icon red.svg" alt="">
                                    </div>
                                    <div class="dropdownMenu-content dropdownActionMenu"
                                        id="actionMenuContent{{booking.id}}" *ngIf="ActionList"
                                        style="top: 24px; right: 0vh;">
                                        <span class="dropdownMenu-content-option"
                                            (click)="NavigateToPaymentRoute(booking)"><img [src]="paymentIcon"
                                                alt="Payment Icon" class="icon-img">Payment</span>
                                        <span class="dropdownMenu-content-option"
                                            (click)="changeDocumentModelState(true,booking)"><img [src]="documentIcon"
                                                alt="Payment Icon" class="icon-img">Documents</span>
                                        <span class="dropdownMenu-content-option"
                                            (click)="changeDocumentModelState(true,booking)"><img [src]="allotmentIcon"
                                                alt="Payment Icon" class="icon-img">Allotment</span>
                                        <span class="dropdownMenu-content-option" data-toggle="modal"
                                            (click)="changeAddUpdateModalState(booking, 'edit')"><img [src]="editIcon"
                                                alt="Payment Icon" class="icon-img">Edit</span>
                                    </div>
                                </div><br>
                                <b><i class="fa fa-user" aria-hidden="true" style="margin-bottom: 10px;">
                                    </i> {{booking?.sourceName}}</b><br>
                                <b><img [src]="receivedAmountIcon" class="icon-img">
                                    {{booking?.recivedAmount}}</b>
                                <br>
                            </h6>
                        </td>
                    </tr>
                </div>
            </div>
        </div>
    </div>
</div>
<app-confirmation-dialog [data]="dialogData" [isVisible]="showDialog" (confirmEvent)="onConfirmed($event)">
</app-confirmation-dialog>

<app-picview *ngIf="showclickedPic" (closePicDialogue)="showclickedPic = false" [picData]="picViewData"></app-picview>

<p-dialog [(visible)]="viewContactModal">
    <p-header>Contact Number</p-header>
    <p-body class="p-2 text-center">
        <div>
            {{ viewedContactNumber }} &nbsp;&nbsp;
            <a [href]="'tel:' + viewedContactNumber" *ngIf="showCallIcon" (click)="clickToCall($event)"
                style="text-decoration: none; color: inherit;" title="Click to call">
                <i class="fa fa-phone" style="color: green; margin-right: 5px;"></i>
            </a>
        </div>
        <div>
        </div>
    </p-body>
</p-dialog>


<!-- Booking Cancellation Modal using reusable component -->
<app-booking-cancellation-modal [isVisible]="showCancellationModalComponent" [mode]="cancellationModalMode"
    [bookingData]="cancelledRowData" [cancellationData]="null" (closeModal)="onCancellationModalClose()"
    (successfulSubmit)="onCancellationSuccessfulSubmit($event)">
</app-booking-cancellation-modal>
